<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import { mapState } from "vuex";
import firebase from "firebase/app";
import { PDFDocument } from "pdf-lib";
import moment from "moment/moment";
import _ from "lodash";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";
import * as XLSX from "xlsx";
import LoadingAnimation from "@/components/admin/automation/loading-animation.vue";
import logActivity from "@/libs/activityLogger";
import { getDefaultArDateRange } from "@/libs/arDateRange";

export default {
  data() {
    const defaultDateRange = getDefaultArDateRange();
    return {
      vendorId: "",
      companyId: "",
      snackbarError: false,
      snackbarErrorMsg: "เกิดข้อผิดพลาด",
      purchaseOrders: [], // Full list of purchase orders
      displayedItems: [], // Items to display on the current page
      currentPage: 1, // Current page
      itemsPerPage:
        localStorage.getItem("pageLimit") &&
        localStorage.getItem("pageLimit") === "auto"
          ? 10
          : Number.parseInt(localStorage.getItem("pageLimit")) || 10, // Items per page
      totalItems: 0, // Total number of items
      selectedItems: [], // Selected POIDs
      selectAll: false, // Select all flag
      dialogDelete: false, // Dialog for confirmation
      selectedDoc: [], // Selected Docline data (array)
      unsubscribe: null, // Listener to unsubscribe from Firestore updates
      editMode: false,
      isUpdating: false,
      selectedDocCopy: null,
      dialogConfirmDocument: false,
      isOpenPoDateMenu: false,
      currentPoDate: "",
      PODateDisp: "",
      currentDeliveryDate: "",
      deliveryDateDisp: "",
      currentSoDate: "",
      SODateDisp: "",
      pdfUrl: "",
      isGettingPdfData: false,
      searchKeywords: "",
      searchPOID: "",
      searchSOID: "",
      searchStartDate: defaultDateRange.fromDate,
      searchEndDate: defaultDateRange.toDate,
      docStatusList: [
        {
          text: "Pending Approval",
          value: "WAITING_TO_CONFIRM",
          colorClass: "pending-color",
        },
        {
          text: "Pending Approval",
          value: "PENDING_APPROVAL",
          colorClass: "pending-color",
        },
        {
          text: "Posting",
          value: "CONFIRMED",
          colorClass: "posting-color",
        },
        {
          text: "Posting",
          value: "POSTING",
          colorClass: "posting-color",
        },
        {
          text: "Warning",
          value: "FAILURE",
          colorClass: "warning-color",
        },
        {
          text: "Warning",
          value: "PO_FAILURE",
          colorClass: "warning-color",
        },
        {
          text: "Warning",
          value: "WARNING",
          colorClass: "warning-color",
        },
        {
          text: "Error",
          value: "SO_FAILURE",
          colorClass: "error-color",
        },
        {
          text: "Error",
          value: "ERROR",
          colorClass: "error-color",
        },
        {
          text: "Success",
          value: "SUCCESS",
          colorClass: "success-color",
        },
      ],
      isOpenCustomDialogue: false,
      searchKeywordsTo: "",
      // Export Dialog
      exportDialog: false,
      menuDatePickerStart: false,
      dateExportStart: null,
      menuDatePickerEnd: false,
      dateExportEnd: null,
      isLoadingDocs: false,
      snackbarCopy: false,
      sortBy: 'SODate', // currently sorted column
      sortDirection: 'asc', // 'asc' or 'desc'
    };
  },
  name: "documentSOAI",
  components: {
    DateRangeSearch,
    LoadingAnimation,
    Admin,
  },
  created() {
    let companyId = this.$route.params.companyId;

    if (companyId) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyId });
    }
  },
  methods: {
    handleEscKey(event) {
      // console.log("event.key::", event.key);
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isOpenCustomDialogue = false;
      }
    },
    sortTable(column) {
      if (this.sortBy === column) {
        // Toggle sort direction if the column is the same
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        // Set the new column and default to ascending order
        this.sortBy = column;
        this.sortDirection = "asc";
      }

      // Perform sorting
      this.purchaseOrders.sort((a, b) => {
        let result = 0;
        if (a[column] < b[column]) result = -1;
        if (a[column] > b[column]) result = 1;

        // Reverse if the direction is descending
        return this.sortDirection === "asc" ? result : -result;
      });

      // Paginate sorted items
      this.paginate();
    },
    getDocStatus(value) {
      const docStatus = this.docStatusList.find(
        (status) => status.value === value
      );
      return docStatus;
    },
    getStatusTH(status) {
      return this.getDocStatus(status)?.text;
    },
    getColorClass(status) {
      return this.getDocStatus(status)?.colorClass;
    },
    nAformmater(value) {
      return value === "N/A" ? "" : value;
    },
    isInvalidValue(value) {
      return value === "N/A" || value === 0;
    },
    checkIfInvalid(doclineItem) {
      return (
        this.isInvalidValue(doclineItem.ItemCode) ||
        this.isInvalidValue(doclineItem.ItemName) ||
        this.isInvalidValue(Number(doclineItem.UnitPriceSO)) ||
        this.isInvalidValue(Number(doclineItem.TotalPriceso))
      );
    },
    getFullName(companyCode) {
      return (
        this.selectedCompanyAutoDocConfig?.find(
          (item) => item.vendorCode === companyCode
        )?.vendorFullName || ""
      );
    },
    formatNum(num) {
      if (!num) return "0";

      // Convert to a string to avoid automatic rounding
      let numStr = num.toString();

      // Find the position of the decimal point
      let decimalIndex = numStr.indexOf(".");

      // If there's a decimal point, truncate to two places
      if (decimalIndex !== -1) {
        numStr = numStr.substring(0, decimalIndex + 3);
      }

      // Convert back to a number for locale formatting
      let truncatedNum = Number(numStr);

      return truncatedNum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async openPDFFile() {
      this.isGettingPdfData = true;
      // console.log("PDF FILE DOC ID:: ", this.selectedDoc.PDFDocRef);
      const companyID = this.$route.params.companyId;

      const purchasePdfFilesRef = fc.db
        .collection(`Companies/${companyID}/PurchasePdfFiles`)
        .doc(this.selectedDoc.PDFDocRef);

      try {
        const purchasePdfFileSnapshot = await purchasePdfFilesRef.get();

        if (purchasePdfFileSnapshot.exists) {
          const pdfPathGs = purchasePdfFileSnapshot.data().pdfPath;
          // console.log("pdfPathGs:: ", pdfPathGs);

          const callGetPDF = firebase.functions().httpsCallable("callGetPDF");
          const data = { gsPdfPath: pdfPathGs };
          const pdfBase64 = (await callGetPDF(data)).data.httpsPath;

          // Convert Base64 string to Uint8Array
          const byteCharacters = atob(pdfBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Load the PDF document with pdf-lib
          const pdfDoc = await PDFDocument.load(byteArray);

          // Set the PDF title property
          pdfDoc.setTitle(this.selectedDoc?.POID);

          // Serialize the PDF document to bytes (Uint8Array)
          const pdfBytes = await pdfDoc.save();

          // Create a new Blob from the modified PDF bytes
          const updatedPdfBlob = new Blob([pdfBytes], {
            type: "application/pdf",
          });

          // Create URL for the updated Blob
          const pdfBlobUrl = URL.createObjectURL(updatedPdfBlob);
          this.pdfUrl = pdfBlobUrl;

          // console.log("pdfBlobUrl: ", pdfBlobUrl);
        } else {
          console.log("Document does not exist");
        }
      } catch (error) {
        console.error("Error retrieving PDF file:", error);
      } finally {
        this.isGettingPdfData = false;
      }
    },
    toggleEditMode() {
      if (!this.editMode) {
        // Create a temporary copy of the selected document
        this.selectedDocCopy = Object.assign({}, this.selectedDoc);
      } else {
        // If cancel is clicked, revert back to the temporary copy
        this.selectedDoc = Object.assign({}, this.selectedDocCopy);
        this.selectedDocCopy = null; // Clear the temporary copy
      }
      this.editMode = !this.editMode;
    },
    async refreshPurchasePdfFile() {
      try {
        const companyID = this.$route.params.companyId;
        const purchasePdfFilesRef = fc.db
          .collection(`Companies/${companyID}/PurchasePdfFiles`)
          .doc(this.selectedDoc.PDFDocRef);

        const purchaseOrderRef = fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(this.selectedDoc.POID);

        await purchaseOrderRef.set(
          {
            Status: "FETCHING",
          },
          { merge: true }
        );

        // console.log("setFetchStatus Success");

        await fc.db.runTransaction(async (transaction) => {
          const docSnapshot = await transaction.get(purchasePdfFilesRef);
          let refreshValue = docSnapshot.data().refresh || 0; // Get current 'refresh' value or default to 0
          refreshValue++;
          transaction.update(purchasePdfFilesRef, { refresh: refreshValue });
        });

        //  console.log('Refreshed the Purchase PDF File.');
      } catch (error) {
        console.error("Error updating the refresh field:", error);
      } finally {
        this.isOpenCustomDialogue = false;
        this.selectedDoc = {};
      }
    },
    exitEditMode() {
      // Clear the temporary copy and exit edit mode
      this.selectedDocCopy = null;
      this.editMode = false;
    },
    async updateDocument() {
      try {
        // Set updating to true to indicate update in progress
        this.isUpdating = true;

        const companyID = this.$route.params.companyId;
        // Update the document in Firebase with new values
        const docRef = fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(this.selectedDoc.POID);
        await docRef.update({
          ...this.selectedDoc,
          Status: "NEW",
        });

        // Update successful
        // console.log("Document updated successfully!");
        this.exitEditMode();
        // Exit edit mode
      } catch (error) {
        // Error handling
        console.error("Error updating document: ", error);
      } finally {
        // Set updating to false regardless of success or failure
        this.editMode = false;
        this.isUpdating = false;
        this.isOpenCustomDialogue = false;
      }
    },
    async confirmDocument() {
      const companyID = this.$route.params.companyId;

      // Filter selected documents that have a status other than "SUCCESS"
      // console.log("selectedItems:: ", this.selectedItems);
      const docsToConfirm = this.purchaseOrders
        .filter((po) => this.selectedItems.includes(po.POID))
        .filter(
          (item) => item.Status !== "SUCCESS" && item.Status !== "CONFIRMED"
        );

      // If there are no documents to confirm, return early
      if (docsToConfirm.length === 0) {
        // Show a message to the user indicating that no documents are eligible for confirmation
        console.log("No documents are eligible for confirmation.");
        return;
      }

      // console.log("docsToConfirm;: ", docsToConfirm);

      // Iterate over each document eligible for confirmation
      for (const selectedDoc of docsToConfirm) {
        const purchaseOrdersRef = fc.db
          .collection(`Companies/${companyID}/PurchaseOrders`)
          .doc(selectedDoc.POID);

        try {
          // Update the status of the current document to "CONFIRMED"
          await purchaseOrdersRef.set({ Status: "CONFIRMED" }, { merge: true });
          // console.log(
          //   `Document with POID ${selectedDoc.POID} confirmed successfully.`
          // );
        } catch (error) {
          console.error(
            `Error confirming document with POID ${selectedDoc.POID}:`,
            error
          );
        } finally {
          this.selectedItems = [];
          this.dialogConfirmDocument = false;
        }
      }

      // Fetch purchase orders to reflect the changes
      this.fetchPurchaseOrders();

      // Close the confirmation dialog
      this.isOpenCustomDialogue = false;
    },

    async fetchPurchaseOrders() {
      this.isLoadingDocs = true;

      try {
        const { searchPOID, searchSOID, searchStartDate, searchEndDate } = this;

        const statusList = ["SUCCESS"];

        const companyID = this.$route.params.companyId;
        const vendorID = this.$route.params.vendorId;

        let query = fc.db.collection(`Companies/${companyID}/PurchaseOrders`);

        // Array to hold orderBy fields
        const orderByFields = [];


        if (vendorID) {
          query = query.where("CompanyCode", "==", vendorID);
        }

        // Filter by POID
        if (searchPOID) {
          // const endKey = `${searchPOID}\uf8ff`;
          // query = query
          //   .where("POID", ">=", searchPOID)
          //   .where("POID", "<=", endKey);
          query = query.where("POID", "==", searchPOID);
          orderByFields.push("POID");
        }

        // Filter by SOID
        if (searchSOID) {
          // const endKey = `${searchSOID}\uf8ff`;
          // query = query
          //   .where("SOID", ">=", searchSOID)
          //   .where("SOID", "<=", endKey);
          query = query.where("SOID", "==", searchSOID);
          orderByFields.push("SOID");
        }

        
        query = query.where("Status", "in", statusList);
        orderByFields.push("Status");

         // Filter by SODate
         if (searchStartDate) {
          const start = new Date(searchStartDate);
          start.setHours(0);

          const end = searchEndDate ? new Date(searchEndDate) : new Date(searchStartDate);
          end.setHours(23, 59, 59, 999);

          query = query.where("SODate", ">=", start)
          query = query.where("SODate", "<=", end);

          // console.log("start:: ", start);
          // console.log("end:: ", end);
          orderByFields.unshift("SODate");
        }

        if (this.unsubscribe) {
          this.unsubscribe();
        }
        this.unsubscribe = query
          .onSnapshot((snapshot) => {
            this.purchaseOrders = snapshot.docs.map((doc) => doc.data());
            this.totalItems = this.purchaseOrders.length;
            this.currentPage = 1; // Reset to first page
            this.paginate(); // Initial pagination
            this.isLoadingDocs = false;
          });
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
        this.isLoadingDocs = false;
      }
    },
    async fetchPurchaseOrdersByDateRange(fromDate, toDate) {
      this.searchStartDate = fromDate;
      this.searchEndDate = toDate;
      await this.fetchPurchaseOrders();
    },
    resetDateSearch() {
      this.resetSearchConfig();
      this.fetchPurchaseOrders();
    },
    paginate() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      this.displayedItems = this.purchaseOrders.slice(startIndex, endIndex);
    },
    toggleAll() {
      if (this.selectAll) {
        this.selectedItems = this.displayedItems.map((item) => item.POID);
      } else {
        this.selectedItems = [];
      }
    },
    confirmDelete() {
      this.dialogDelete = true;
    },
    async deleteSelectedItems() {
      // Delete selected items by their POIDs
      for (const POID of this.selectedItems) {
        // Example: You can use Firebase to delete items
        try {
          const companyID = this.$route.params.companyId;
          await fc.db
            .collection(`Companies/${companyID}/PurchaseOrders`)
            .doc(POID)
            .delete();
        } catch (error) {
          console.error(`Error deleting item with POID ${POID}:`, error);
        }
      }
      // After deletion, clear selected items
      this.selectedItems = [];
      // No need to refetch data, as it updates in real-time
      // Close the confirmation dialog
      this.dialogDelete = false;
    },
    // Method to show Docline details dialog
    showDocDetailDialog(doc) {
      this.isOpenCustomDialogue = true;
      this.selectedDoc = { ...doc };
    },
    debounceInput: _.debounce(function () {
      this.fetchPurchaseOrders();
    }, 1000),
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");

      const date = new Date(timestamp.seconds * 1000);

      // Format the date with Thai month and Buddhist year
      const formattedDate = moment(date).add(543, "years").format("DD MMM YY");

      return formattedDate;
    },
    getCheckboxValue(item) {
      return `${item.POID}`;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbarCopy = true;
    },
    resetSearchConfig() {
      const defaultDateRange = getDefaultArDateRange();
      this.searchPOID = "";
      this.searchSOID = "";
      // Back to the default window, not to null: an empty filter subscribes to
      // the whole PurchaseOrders collection.
      this.searchStartDate = defaultDateRange.fromDate;
      this.searchEndDate = defaultDateRange.toDate;
    },
    intPage() {
      this.vendorId = this.$route.params?.vendorId || "";
      this.companyId = this.$route.params?.companyId || "";
    },
    cancelExportDocs() {
      this.exportDialog = false;
      this.$refs.form.reset();
    },
    async exportDocs() {
      if (!this.dateExportStart) {
        this.snackbarError = true;
        this.snackbarErrorMsg = "กรุณาเลือกวันที่เริ่มต้น";
        return;
      }
      if (!this.dateExportEnd) {
        this.snackbarError = true;
        this.snackbarErrorMsg = "กรุณาเลือกวันที่สิ้นสุด";
        return;
      }

      const startDate = new Date(this.dateExportStart);
      startDate.setHours(0);
      const endDate = new Date(this.dateExportEnd);
      endDate.setHours(23, 59, 59, 999);

      if (startDate > endDate) {
        this.snackbarError = true;
        this.snackbarErrorMsg = "วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด";
        return;
      }

      const status = "SUCCESS";
      let query = fc.db
        .collection(`Companies/${this.companyId}/PurchaseOrders`)
        .where("Status", "==", status);
      if (this.vendorId) {
        query = query.where("CompanyCode", "==", this.vendorId);
      }
      query = query
        .where("SODate", ">=", startDate)
        .where("SODate", "<=", endDate);
      const exportData = [];
      await query.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const temp = doc.data();
          delete temp.Docline;
          exportData.push({
            [`สถานะเอกสาร (Status)`]: this.getStatusTH(temp.Status),
            [`วันที่เอกสารใบสั่งขาย (SO Date)`]: this.getThaiDate(temp.SODate),
            [`เลขที่เอกสารใบสั่งขาย (SO No.)`]: temp.SOID,
            [`วันที่เอกสารใบสั่งซื้อ (PO Date)`]: this.getThaiDate(temp.PODate),
            [`เลขที่เอกสารใบสั่งซื้อ (PO No.)`]: temp.POID,
            [`รหัสลูกค้า (Customer Code)`]: temp.CardCode,
            [`ชื่อลูกค้า (Customer Name)`]: temp.CardNameTH,
            [`รหัสสาขา (Branch Code)`]: temp.GlblLocNum,
            [`สาขาลูกค้า (Branch Name)`]: temp.BranchNameTH,
            [`มูลค่าก่อนภาษี (Price Before Vat)`]: this.formatNum(
              temp.SubTotalSO
            ),
            [`ภาษีมูลค่าเพิ่ม (Vat)`]: this.formatNum(temp.VATSO),
            [`มูลค่ารวม (Total)`]: this.formatNum(temp.Doctotal),
            [`สถานที่ส่งสินค้า (Ship To)`]: temp.ShipTo,
            [`หมายเหตุ (Remark)`]: temp.Remark,
          });
        });
      });

      if (exportData.length === 0) {
        this.snackbarError = true;
        this.snackbarErrorMsg =
          "ไม่พบข้อมูลที่ต้องการส่งออก กรุณาเลือกระยะเวลาใหม่";
        return;
      }
      const header = Object.keys(exportData[0]);


      const worksheet = XLSX.utils.json_to_sheet(exportData, {
        header: header,
      });

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "SaleOrders");

      const fileName = `SaleOrders_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    },
    downloadPdf() {
      if (!this.pdfUrl) {
        this.snackbarError = true;
        this.snackbarErrorMsg = "ไม่พบไฟล์ PDF";
        return;
      }

      try {
        // Create a temporary anchor element to trigger the download
        const a = document.createElement("a");
        a.href = this.pdfUrl;
        a.download = `SaleOrder_${this.selectedDoc.SOID}.pdf`;
        document.body.appendChild(a);
        a.click();

        // Clean up the temporary element
        document.body.removeChild(a);

        this.snackbarCopy = true;

        console.log("Download initiated for SOID", this.selectedDoc.SOID);
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.snackbarError = true;
        this.snackbarErrorMsg = "ดาวน์โหลด PDF ไม่สำเร็จ";
      }
    },
  },
  computed: {
    ...mapState({
      selectedCompanyAutoDocConfig: (state) =>
        state.companies.selectedCompanyAutoDocConfig,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
    }),
    itemsRangeText() {
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(
        this.currentPage * this.itemsPerPage,
        this.totalItems
      );
      return `${start} - ${end} จาก ${this.totalItems}`;
    },
    currentVendor() {
      return this.selectedCompanyAutoDocConfig.find(
        (item) => item.vendorCode === this.$route.params.vendorId
      );
    },
    formattedPODate() {
      if (this.selectedDoc?.PODate instanceof Date) {
        const parts = this.selectedDoc?.PODate.toLocaleDateString().split("/");
        // Rearrange the parts to form the desired format
        const formattedDate = `${parts[2]}-${parts[0].padStart(
          2,
          "0"
        )}-${parts[1].padStart(2, "0")}`;

        return formattedDate;
      }
      var milliseconds =
        this.selectedDoc?.PODate.seconds * 1000 +
        this.selectedDoc?.PODate.nanoseconds / 1000000 +
        100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);
      const parts = date.toLocaleDateString().split("/");
      // Rearrange the parts to form the desired format
      const formattedDate = `${parts[2]}-${parts[0].padStart(
        2,
        "0"
      )}-${parts[1].padStart(2, "0")}`;

      return formattedDate;
    },
    formattedDeliveryDate() {

  

      if (
        !this.selectedDoc?.DeliveryDate ||
        this.selectedDoc?.DeliveryDate === "Invalid Date"
      ) return "";

  

      if (this.selectedDoc?.DeliveryDate instanceof Date) {
        const parts =
          this.selectedDoc?.DeliveryDate.toLocaleDateString().split("/");
        // Rearrange the parts to form the desired format
        const formattedDate = `${parts[2]}-${parts[0]?.padStart(
          2,
          "0"
        )}-${parts[1]?.padStart(2, "0")}`;

        return formattedDate;
      }
      var milliseconds =
        this.selectedDoc?.DeliveryDate?.seconds * 1000 +
        this.selectedDoc?.DeliveryDate?.nanoseconds / 1000000 +
        100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);
      const parts = date.toLocaleDateString().split("/");
      // Rearrange the parts to form the desired format
      const formattedDate = `${parts[2]}-${parts[0]?.padStart(
        2,
        "0"
      )}-${parts[1]?.padStart(2, "0")}`;

      return formattedDate;
    },
    formattedSODate() {

      if (
        !this.selectedDoc?.SODate ||
        this.selectedDoc?.SODate === "Invalid Date"
      ) return "";

  

      if (this.selectedDoc?.SODate instanceof Date) {
        const parts = this.selectedDoc?.SODate.toLocaleDateString().split("/");
        // Rearrange the parts to form the desired format
        const formattedDate = `${parts[2]}-${parts[0].padStart(
          2,
          "0"
        )}-${parts[1].padStart(2, "0")}`;

        return formattedDate;
      }
      var milliseconds =
        this.selectedDoc?.SODate.seconds * 1000 +
        this.selectedDoc?.SODate.nanoseconds / 1000000 +
        100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);
      const parts = date.toLocaleDateString().split("/");
      // Rearrange the parts to form the desired format
      const formattedDate = `${parts[2]}-${parts[0].padStart(
        2,
        "0"
      )}-${parts[1].padStart(2, "0")}`;

      return formattedDate;
    },
    formattedVATSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.VATSO);
    },
    formattedSubTotalSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotalSO);
    },
    formattedDiscountSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.DiscountSO);
    },
    formattedDoctotalSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.DoctotalSO);
    },
    formattedReferenceSOID() {
      // Format the VAT value using Intl.NumberFormat
      return this.selectedDoc.DocEntrySO
    },
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    areItemsSelected() {
      return this.selectedItems.length > 0;
    },
    isDocUnchanged() {
      return _isEqual(this.selectedDoc, this.selectedDocCopy);
    },
    areDocsEligibleForConfirmation() {
      // Check if there are selected documents and if all of them have a status other than "SUCCESS"
      return (
        this.selectedItems?.length > 0 &&
        this.purchaseOrders
          ?.filter((po) => this.selectedItems.includes(po.POID))
          ?.every(
            (doc) => doc.Status === "SUCCESS" || doc.Status === "CONFIRMED"
          )
      );
    },
  },
  watch: {
    currentPage() {
      this.paginate();
    },
    selectedDoc() {
      this.currentPoDate = this.formattedPODate;
      this.currentSoDate = this.formattedSODate;
      this.currentDeliveryDate = this.formattedDeliveryDate;
    },
    currentPoDate() {
      // Split the date string into year, month, and day
      const parts = this.currentPoDate.split("-");
      // Rearrange the parts to form the desired format
      this.PODateDisp = `${parts[2]}/${parts[1]}/${parts[0]}`;
      this.selectedDoc.PODate = new Date(this.currentPoDate);
    },
    currentSoDate() {
      // Split the date string into year, month, and day
      const parts = this.currentSoDate.split("-");
      // Rearrange the parts to form the desired format
      this.SODateDisp = `${parts[2]}/${parts[1]}/${parts[0]}`;
      this.selectedDoc.SODate = new Date(this.currentSoDate);
    },
    currentDeliveryDate(newVal) {
      if (!newVal) {
        this.deliveryDateDisp = "";
        return;
      }
      const [yyyy, mm, dd] = newVal.split("-");
      this.deliveryDateDisp = `${dd}/${mm}/${yyyy}`;
      this.$set(this.selectedDoc, "DeliveryDate", new Date(newVal));
    },
    isOpenCustomDialogue(oldValue, newValue) {
      if (newValue === false) {
        this.pdfUrl = "";
        this.openPDFFile();
        this.editMode = false;
      }
    },
    selectedItems() {
      this.selectAll = this.selectedItems.length === this.displayedItems.length;
    },
    $route: {
      handler() {
        this.intPage();
        // console.log("vendorId:: ", this.vendorId);
        // console.log("companyId:: ", this.companyId);
        this.resetSearchConfig();
        this.fetchPurchaseOrders();
      },
      deep: true,
    },
    dateExportStart() {
      if (!this.dateExportEnd) {
        this.dateExportEnd = this.dateExportStart;
      }
      if (this.dateExportEnd < this.dateExportStart) {
        this.dateExportEnd = this.dateExportStart;
      }
    },
  },
  mounted() {
    logActivity("page_view", { page_title: "DocumentSOAI" });
    this.intPage();

    let { startDate = "", endDate = "" } = this.$route.query;
    // console.log("startDate -->", startDate);
    // console.log("endDate -->", endDate);

    if (startDate) {
      this.searchStartDate = startDate;
    }

    if (endDate) {
      this.searchEndDate = endDate;
    }

    this.fetchPurchaseOrders();
    window.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    // Unsubscribe from Firestore updates when component is destroyed
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    window.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>
<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <v-container fluid>
        <v-card>
          <div class="table-container">
            <div v-if="vendorId !== ''" class="ma-4">
              <h3 class="tw-text-xl">
                <div
                  class="tw-flex tw-items-center tw-gap-2 tw-text-base"
                  v-if="currentVendor?.vendorFullName"
                >
                  <img
                    v-if="currentVendor?.logo"
                    :src="currentVendor?.logo"
                    class="tw-w-8 tw-h-8 tw-object-contain"
                  />

                  <div
                    v-else
                    src="/images/logo.png"
                    class="tw-w-8 tw-h-8 tw-object-contain tw-bg-gray-500 tw-rounded tw-flex tw-items-center tw-justify-center"
                  >
                    <v-icon size="24">mdi-city</v-icon>
                  </div>
                  {{ currentVendor?.vendorFullName }} - เลขที่ผู้เสียภาษี
                  {{ currentVendor?.taxId }}
                </div>
                <span v-else
                  ><v-icon size="32">mdi-city</v-icon>
                  <v-icon class="mdi-spin">mdi-refresh</v-icon></span
                >
              </h3>
            </div>
            <hr v-if="vendorId !== ''" class="tw-mx-4 tw-pt-2 tw-opacity-10" />
            <div class="pt-8 table-toolbar">
              <v-row class="px-3 pa-0 tw-gap-4">
                <v-col cols="2" class="pa-0">
                  <v-btn
                    color="primary"
                    class="py-4 tw-text-sm tw-tracking-normal"
                    elevation="0"
                    @click="exportDialog = true"
                    outlined
                  >
                    <v-icon left>mdi-table-arrow-right</v-icon>
                    ส่งออกข้อมูล
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="tw-flex pa-0" cols="2">
                  <v-text-field
                    dense
                    class="ma-0 pa-0"
                    label="เลขที่ใบสั่งซื้อ (PO No.)"
                    v-model="searchPOID"
                    @input="(n) => debounceInput(n, null)"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="tw-flex pa-0" cols="2">
                  <v-text-field
                    dense
                    class="ma-0 pa-0"
                    label="เลขที่ใบสั่งขาย (SO No.)"
                    v-model="searchSOID"
                    @input="(n) => debounceInput(n, null)"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="pa-0" cols="4">
                  <date-range-search
                    outline
                               :initial-from-date="searchStartDate"
                    :initial-to-date="searchEndDate"
                    :on-reset="resetDateSearch"
                    :on-search="fetchPurchaseOrdersByDateRange"
                  />
                </v-col>
              </v-row>
            </div>
          <table class="custom-table tw-text-sm">
            <thead>
              <tr>
                <th>สถานะเอกสาร <br />(Status)</th>
                <th class="tw-cursor-pointer" @click="sortTable('SODate')">
                  วันที่ใบสั่งขาย<br />(SO Date)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'SODate'">
                      {{ sortDirection === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('SOID')">
                    เลขที่ใบสั่งขาย<br />(SO No.)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'SOID'">
                      {{ sortDirection === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('POID')">
                    เลขที่เอกสารใบสั่งซื้อ<br />(PO No.)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'POID'">
                      {{ sortDirection === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('CardCode')">
                    รหัสลูกค้า<br />(Customer Code)
                    <!-- Only show the icon if this column is currently sorted -->
                    <v-icon v-if="sortBy === 'CardCode'">
                      {{ sortDirection === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </th>
                <th>ชื่อลูกค้า <br />(Customer Name)</th>
                <th>สาขาลูกค้า <br />(ฺBranch Name)</th>
                <th class="tw-text-right">
                  มูลค่าก่อนภาษี <br />(Price Before Vat)
                </th>
                <th class="tw-text-right">ภาษีมูลค่าเพิ่ม <br />(Vat)</th>
                <th class="tw-text-right">มูลค่ารวมทั้งสิ้น <br />(Total)</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in displayedItems"
                :key="index"
                @click="showDocDetailDialog(item)"
              >
                <td class="tw-text-xs">
                  <v-tooltip
                    top
                    v-if="
                      item.FailureMessage !== '' &&
                      item.FailureMessage !== 'N/A'
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        :class="`status-card ${getColorClass(item.Status)}`"
                      >
                        {{ getStatusTH(item.Status) }}
                      </div>
                    </template>
                    <span>{{ item.FailureMessage }}</span>
                  </v-tooltip>
                  <div
                    v-else
                    :class="`status-card ${getColorClass(item.Status)}`"
                  >
                    {{ getStatusTH(item.Status) }}
                  </div>
                </td>
                <td>{{ getThaiDate(item.SODate) }}</td>
                <!-- TODO: change to SODate -->
                <td @click.stop>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        @click="copyToClipboard(item.SOID)"
                        class="hover:tw-opacity-70"
                        style="user-select: none"
                        >{{ item.SOID }}</span
                      >
                    </template>
                    <span>
                      <v-icon color="white">mdi-content-copy</v-icon>
                      คลิกเพื่อคัดลอก</span
                    >
                  </v-tooltip>
                </td>
                <td @click.stop>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        @click="copyToClipboard(item.POID)"
                        class="hover:tw-opacity-70"
                        style="user-select: none"
                        >{{ item.POID }}</span
                      >
                    </template>
                    <span>
                      <v-icon color="white">mdi-content-copy</v-icon>
                      คลิกเพื่อคัดลอก</span
                    >
                  </v-tooltip>
                </td>
                <td>{{ item.CardCode }}</td>
                <td>{{ item.CardNameTH }}</td>
                <td>{{ item.BranchNameTH }}</td>
                <td class="tw-text-right">{{ formatNum(item.SubTotalSO) }}</td>
                <td class="tw-text-right">{{ formatNum(item.VATSO) }}</td>
                <td class="tw-text-right">{{ formatNum(item.DoctotalSO) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

          <div
            v-if="purchaseOrders.length === 0 && !isLoadingDocs"
            class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
          >
            <h2>ไม่พบเอกสารที่ต้องการ</h2>
          </div>
          <v-progress-linear
            indeterminate
            color="green"
            :active="isLoadingDocs"
          ></v-progress-linear>
          <!-- Pagination Controls -->
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <div class="tw-px-4">
            {{ itemsRangeText }}
          </div>
          <v-spacer />
          <v-pagination
            v-model="currentPage"
            :length="numPages"
            :total-visible="6"
            @input="paginate"
          ></v-pagination>
          <v-spacer />
        </v-row>
      </v-container>
      <!-- Confirmation Dialog -->
      <v-dialog v-model="dialogDelete" max-width="400">
        <v-card>
          <v-card-title>ยืนยันการลบ</v-card-title>
          <v-card-text class="tw-text-lg"
            >คุณแน่ใจหรือไม่ว่าต้องการลบรายการที่เลือก?</v-card-text
          >
          <v-card-actions>
            <v-btn
              color="green darken-1"
              text
              class="tw-text-lg"
              @click="dialogDelete = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="red darken-1"
              text
              class="tw-text-lg"
              @click="deleteSelectedItems"
              >ลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- custom dialog template  -->
      <div v-if="isOpenCustomDialogue" class="custom-dialogue">
        <div if="selectedDoc" class="custom-dialogue-content-wrapper">
          <!-- header title  -->
          <div class="dialog-header-wrapper">
            <div class="tw-flex tw-justify-center">
              <span
                :class="`status-card-dialogue tw-text-sm  ${getColorClass(
                  selectedDoc.Status
                )} `"
              >
                {{ getStatusTH(selectedDoc.Status) }}
              </span>
            </div>
          </div>
          <!-- content  -->
          <div class="dialog-content-wrapper">
            <div
              class="dialog-content-left tw-rounded-lg tw-overflow-hidden tw-border-2 tw-bg-pdf-gray"
            >
              <embed
                v-if="!isGettingPdfData"
                :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
                type="application/pdf"
                width="100%"
                height="100%"
              />
              <div
                v-else
                class="tw-h-full tw-w-full tw-flex tw-justify-center tw-items-center"
              >
                <LoadingAnimation />
              </div>
            </div>
            <div class="dialog-content-right">
              <div
                class="tw--translate-y-4 tw-transform tw-pt-10 tw-h-full tw-overflow-y-scroll"
              >
                <v-row class="mx-2">
                  <v-col cols="6" xs="12" class="py-0">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="ชื่อลูกค้า (Customer Name)"
                      dense
                      readonly
                      :disabled="editMode"
                      :value="selectedDoc.BranchNameTH"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" xs="6" class="py-0">
                    <v-text-field
                      required
                      class="ma-0 pa-0"
                      readonly
                      dense
                      label="สาขาลูกค้า (Branch Code) *"
                      v-model="selectedDoc.GlblLocNum"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="6" xs="12" class="py-0">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="ใบสั่งขาย (SO No.)"
                      readonly
                      dense
                      :value="selectedDoc.SOID"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="12" class="py-0">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="เลขที่อ้างอิง SO (Reference SO No.)"
                      readonly
                      dense
                      :value="formattedReferenceSOID"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="12" class="py-0">
                    <v-text-field
                      label="วันที่ใบสั่งขาย (SO Date)"
                      append-icon="mdi-calendar-month-outline"
                      readonly
                      dense
                      :value="SODateDisp"
                      outlined
                      v-on="editMode ? on : {}"
                    ></v-text-field>
                    
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      label="วันที่ส่งสินค้า (Delivery Date)"
                      append-icon="mdi-calendar-month-outline"
                      readonly
                      dense
                      :value="deliveryDateDisp"
                      outlined
                      v-on="editMode ? on : {}"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      label="เลขที่ใบสั่งซื้อ (PO No.)"
                      :value="selectedDoc?.POID"
                      outlined
                      dense
                      readonly
                    ></v-text-field
                  ></v-col>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      label="ผู้จัดทำ (Owner)"
                      :value="(selectedDoc?.OwnerData?.nameFirstTH || '')+ ' ' + (selectedDoc?.OwnerData?.nameLastTH || '')"
                      outlined
                      dense
                      readonly
                    ></v-text-field
                  ></v-col>
               
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12" xs="12" class="py-0">
                    <v-textarea
                      class="ma-0 pa-0"
                      label="สถานที่ส่งสินค้า (Ship To)"
                      dense
                      v-model="selectedDoc.ShipTo"
                      outlined
                      :readonly="!editMode"
                      rows="1"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <div class="table-container-detail tw-text-sm">
                  <table class="mx-5 customer-table-detail">
                    <thead>
                      <tr>
                        <th>ลำดับ <br />(No.)</th>
                        <th>รหัสสินค้า <br />(Item Code)</th>
                        <th>ชื่อสินค้า <br />(Item Name)</th>
                        <th class="tw-text-right">จำนวน <br />(Qty.)</th>
                        <th class="tw-text-right tw-whitespace-nowrap">
                          ราคาต่อหน่วย <br />(Unit Price)
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      :class="{
                        'tw-text-red-500': checkIfInvalid(doclineItem),
                      }"
                      v-for="(doclineItem, index) in selectedDoc?.Docline"
                      :key="index"
                    >
                      <tr>
                        <td rowspan="2">{{ index + 1 }}</td>
                        <td>{{ nAformmater(doclineItem.Vendor_ItemCode) }}</td>
                        <td>{{ nAformmater(doclineItem.Vendor_ItemName) }}</td>
                        <td rowspan="2" class="tw-text-center">
                          {{ formatNum(doclineItem.Quantity) }}
                        </td>
                        <td rowspan="2" class="tw-text-right">
                          {{ formatNum(doclineItem.UnitPriceSO) }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ nAformmater(doclineItem.ItemCode) }}</td>
                        <td>{{ nAformmater(doclineItem.ItemName) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="tw-mb-8 tw-mt-10">
                  <v-row class="mx-2 tw-flex tw-justify-end">
                    <v-col cols="3" xs="12" class="py-0">
                      <v-text-field
                        class="ma-0 pa-0"
                        label="มูลค่าก่อนภาษี (Price Before Vat)"
                        readonly
                        dense
                        v-model="formattedSubTotalSO"
                        type="text"
                        reverse
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" xs="12" class="py-0">
                      <v-text-field
                        class="ma-0 pa-0"
                        label="ส่วนลด (Discount)"
                        type="text"
                        readonly
                        dense
                        v-model="formattedDiscountSO"
                        outlined
                        reverse
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" xs="12" class="py-0">
                      <v-text-field
                        class="ma-0 pa-0"
                        label="ภาษีมูลค่าเพิ่ม (Vat)"
                        reverse
                        dense
                        readonly
                        v-model="formattedVATSO"
                        type="text"
                        :text-right="true"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" xs="12" class="py-0">
                      <v-text-field
                        class="ma-0 pa-0"
                        label="มูลค่ารวมทั้งสิ้น (Total)"
                        v-model="formattedDoctotalSO"
                        outlined
                        dense
                        readonly
                        type="text"
                        reverse
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mx-2">
                    <v-col cols="12" xs="12" class="py-0">
                      <v-textarea
                        class="ma-0 pa-0"
                        label="หมายเหตุ (Remark)"
                        :readonly="!editMode"
                        v-model="selectedDoc.Remark"
                        outlined
                        dense
                        rows="3"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-footer-wrapper tw-flex tw-gap-2">
            <v-spacer></v-spacer>

            <v-btn
              color="#cbd5e1"
              v-if="!editMode"
              :disabled="isUpdating"
              class="tw-tracking-normal"
              @click="isOpenCustomDialogue = false"
            >
              <v-icon left>mdi-close</v-icon>
              ปิด</v-btn
            >
            <v-btn
              color="#6ec39b"
              v-if="!editMode"
              :disabled="isUpdating"
              class="tw-tracking-normal"
              @click="downloadPdf"
            >
              <v-icon left>mdi-download</v-icon>
              ดาวน์โหลด PDF</v-btn
            >
          </div>
        </div>
      </div>
      <v-snackbar timeout="2000" v-model="snackbarCopy" color="success" top>
        <!-- copy alt icon  -->
        <v-icon left>mdi-check</v-icon>
        คัดลอกเรียบร้อย
      </v-snackbar>
    </v-main>
    <v-dialog v-model="exportDialog" persistent max-width="400px">
      <v-form ref="form">
        <v-card>
          <v-card-title>
            <b>ส่งออกข้อมูล</b>
          </v-card-title>
          <v-card-text class="tw-pb-0">
            <v-menu
              v-model="menuDatePickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="dateExportStart"
                  label="วันที่เอกสารเริ่มต้น"
                  append-icon="mdi-calendar"
                  persistent-placeholder
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateExportStart"
                @input="menuDatePickerStart = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              v-model="menuDatePickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="dateExportEnd"
                  persistent-placeholder
                  label="วันที่เอกสารสิ้นสุด"
                  append-icon="mdi-calendar"
                  :disabled="!dateExportStart"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateExportEnd"
                :allowed-dates="
                  (date) => new Date(date) >= new Date(dateExportStart)
                "
                @input="menuDatePickerEnd = false"
              ></v-date-picker>
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cancelExportDocs">
              <v-icon>mdi-close-circle-outline</v-icon>
              <b>ยกเลิก</b>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="#6ec39b"
              type="button"
              class="btn-submit"
              :disabled="!dateExportStart || !dateExportEnd"
              @click="exportDocs"
            >
              <b>ส่งออกข้อมูล</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar timeout="2500" v-model="snackbarError" color="error" top>
      {{ snackbarErrorMsg }}
    </v-snackbar>
  </Admin>
</template>

<style lang="scss" scoped>
* {
  --warning-color: rgb(255, 178, 76);
  --warning-bg-color: rgb(255, 178, 77, 0.2);
  --error-color: rgb(173, 15, 1);
  --error-bg-color: rgb(173, 15, 1, 0.2);
  --pending-color: rgb(97, 163, 255);
  --pending-bg-color: rgba(97, 163, 255, 0.2);
  --posting-color: rgb(159, 152, 255);
  --posting-bg-color: rgba(159, 152, 255, 0.2);
  --fetching-color: #777a82;
  --fetching-bg-color: rgba(119, 122, 130, 0.2);
  --new-color: #4794eb;
  --new-bg-color: rgba(71, 148, 235, 0.2);
  --text-color: #ffffff;
  --success-color: #0fb45f;
  --success-bg-color: rgba(15, 180, 95, 0.2);
}

.error-color {
  color: var(--error-color);
  background-color: var(--error-bg-color);
  display: inline-block;
}

.success-color {
  color: var(--success-color);
  background-color: var(--success-bg-color);
  display: inline-block;
}

.warning-color {
  color: var(--warning-color);
  background-color: var(--warning-bg-color);
  display: inline-block;
}

.fetching-color {
  color: var(--fetching-color);
  background-color: var(--fetching-bg-color);
  display: inline-block;
}

.pending-color {
  color: var(--pending-color);
  background-color: var(--pending-bg-color);
  display: inline-block;
}
.new-color {
  color: var(--new-color);
  background-color: var(--new-bg-color);
  display: inline-block;
}

.posting-color {
  color: var(--posting-color);
  background-color: var(--posting-bg-color);
  display: inline-block;
}

.status-card {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  max-width: 200px;
}

.status-card-dialogue {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1.3rem;
}

.table-container {
  width: 100%; /* Adjust the width as needed */
  overflow-x: auto;

  td,
  th {
    white-space: nowrap;
  }
}

.table-container-detail {
  width: 100%; /* Adjust the width as needed */

  td,
  th {
    white-space: wrap;
    font-weight: 500;
  }
}
.customer-table-detail {
  width: calc(100% - 2.7rem);
  /* border: 2px solid red; */
}
/* Styling for table headers */
.customer-table-detail th {
  padding: 10px;
  text-align: left;
}

/* Styling for table cells */
.customer-table-detail td {
  padding: 10px;
  height: 40px;
  border: 1px solid rgba(182, 182, 182, 0.528);
}

/* Styling for table rows */
.customer-table-detail tbody tr {
  padding: 10px; /* Add padding to each row */
}
.customer-table-detail tbody {
  border-bottom: 2px solid rgb(182, 182, 182);
}
.customer-table-detail tbody:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}
.customer-table-detail tbody:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

/* ---------------------- */

.table-toolbar {
  padding: 1rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100%; /* Make table width 100% of container */
}

/* Styling for table headers */
.custom-table th {
  padding: 0 16px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
  font-weight: 500;
}

/* Styling for table cells */
.custom-table td {
  padding: 0 16px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
}

/* Styling for table rows */
.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 10px; /* Add padding to each row */
  height: 3rem; /* Add height to each row */
}
.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}
.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

/* ----------- */

.custom-dialogue {
  position: fixed;
  z-index: 99;
  padding: 1.5rem;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s;
}

.custom-dialogue-content-wrapper {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  height: 100%;
  width: 100%;
  /* border: 5px solid green; */
}

.dialog-header-wrapper {
  /* border: 2px solid green; */
  height: 2.7rem;
}

/* Default styles for .dialog-content-wrapper */
.dialog-content-wrapper {
  /* border: 2px solid red; */
  display: flex;
  padding: 8px 0px;
  height: calc(100% - 2.7rem * 2);
  width: 100%;
}

.dialog-content-left {
  /* border: 2px solid red; */
  width: 40%;
}

.dialog-content-right {
  /* border: 2px solid green; */
  flex: 1;
}

@media (max-width: 947px) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
  }

  .dialog-content-right {
    /* border: 2px solid green; */
    height: calc(60% - 2.7rem);
  }
}
.dialog-footer-wrapper {
  /* border: 2px solid blue; */
  height: 2.7rem;
}

@media screen and (max-width: 947px), screen and (orientation: portrait) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    min-height: 40%;
    margin-bottom: 1rem;
  }

  .dialog-content-right {
    width: 100%;
    height: auto;
    overflow-y: auto;
  }
}


</style>
